import { motion } from "framer-motion";
import { Link } from "gatsby";
import React from "react";

import { ArrowIcon } from "../Icons";
import * as styles from "./styles.module.css";

const arrowMotion = {
  rest: { x: 0 },
  hover: { x: 15 },
};
const ArrowLink = ({ href, children, color }) => (
  <motion.a
    href={href}
    className={styles.link}
    initial="rest"
    whileHover="hover"
  >
    <span>{children}</span>
    <motion.span variants={arrowMotion}>
      <ArrowIcon color={color} />
    </motion.span>
  </motion.a>
);

export const ArrowLinkLocal = ({ href, children, color }) => (
  <Link to={href}>
    <motion.div className={styles.link} initial="rest" whileHover="hover">
      <span>{children}</span>
      <motion.span variants={arrowMotion}>
        <ArrowIcon color={color} />
      </motion.span>
    </motion.div>
  </Link>
);

export default ArrowLink;
